import type { StyleLayer } from './utils/types'

export const layers_places: StyleLayer[] = [
  {
    id: 'places-names',
    type: 'symbol',
    filter: ['match', ['get', 'place'], ['town', 'village', 'city'], true, false],
    minzoom: 9,
    layout: {
      'icon-allow-overlap': true,
      'icon-padding': 0,
      'icon-size': [
        'match',
        ['get', 'population'],
        ['6452'],
        3,
        ['8945'],
        4,
        ['10633', '11355'],
        5,
        ['17017'],
        8,
        ['38111'],
        19,
        1,
      ],
      'text-anchor': 'top',
      'text-field': [
        'step',
        ['zoom'],
        ['to-string', ['get', 'name']],
        10,
        ['to-string', ['concat', ['get', 'name'], ' \n ', ['get', 'population']]],
      ],
      'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Regular'],
      'text-max-width': 20,
      'text-offset': [0, 1],
      'text-padding': 0,
      'text-size': ['interpolate', ['linear'], ['zoom'], 10, 10, 22, 13],
    },
    paint: {
      'text-color': '#594f4f',
      'text-halo-color': 'hsla(0, 6%, 97%, 0.91)',
      'text-halo-width': 1,
      'text-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        9,
        ['match', ['get', 'place'], ['city', 'town'], 1, 0],
        10,
        ['match', ['get', 'place'], ['city', 'town'], 1, 0],
        10.5,
        ['match', ['get', 'place'], ['city', 'town', 'village'], 1, 0],
      ],
    },
  },
]
